import PropTypes from 'prop-types'
import React from 'react'
import { Button, IconButton, Tooltip } from '@mui/material'
import { Link } from 'react-router-dom'

function ToolbarButton(props) {
  const tooltip = props.tooltip || props.title

  const renderButton = () => {
    // A disabled MUI button has no pointer events, so its tooltip never opens.
    // The span gives the tooltip something that can still receive them.
    if (props.disabled) {
      return <span>{renderControl()}</span>
    }

    return renderControl()
  }

  const renderControl = () => {
    if (props.icon) {
      return (
        <IconButton
          aria-label={props.title}
          className={props.className}
          disabled={props.disabled}
          onClick={props.onClick}
          sx={{ ml: 2 }}
        >
          {props.icon}
        </IconButton>
      )
    } else {
      return (
        <Button
          aria-label={props.title}
          className={props.className}
          disabled={props.disabled}
          endIcon={props.endIcon}
          onClick={props.onClick}
          startIcon={props.startIcon}
          style={{ color: props.color }}
          sx={{ ml: 2 }}
          variant={props.variant}
        >
          {props.title}
        </Button>
      )
    }
  }

  if (props.route) {
    return (
      <Tooltip key={props.title} title={tooltip}>
        <Link to={props.route}>{renderButton()}</Link>
      </Tooltip>
    )
  } else {
    return props.disableTooltip ? (
      renderButton()
    ) : (
      <Tooltip key={props.title} title={tooltip}>
        {renderButton()}
      </Tooltip>
    )
  }
}

ToolbarButton.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  route: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  disableTooltip: PropTypes.bool,
  endIcon: PropTypes.node,
  startIcon: PropTypes.node,
  className: PropTypes.node,
}

ToolbarButton.defaultProps = {
  variant: 'text',
  disableTooltip: false,
}

export default ToolbarButton
